import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import DangerBox from 'components/Web_User_Interface/1440p_Series/Live_Video/DangerBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/LiveStreamPerm';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Live Video",
  "path": "/Web_User_Interface/1440p_Serie/Live_Video/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Live Video, Pan&Tilt Kontrolle, Quick-Access Kacheln und SD Karten Viewer.",
  "image": "./QI_SearchThumb_LiveVideo.webp",
  "social": "/images/Search/QI_SearchThumb_LiveVideo.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Live Video :: INSTAR 2k+ (WQHD) Web User Interface' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Live Video, Pan&Tilt Kontrolle, Quick-Access Kacheln und SD Karten Viewer.' image='/images/Search/QI_SearchThumb_LiveVideo.webp' twitter='/images/Search/QI_SearchThumb_LiveVideo.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Live_Video/' locationFR='/fr/Web_User_Interface/1440p_Series/Live_Video/' crumbLabel="Live Video" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h2 {...{
      "id": "live-video",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#live-video",
        "aria-label": "live video permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Live Video`}</h2>
    <p>{`Wenn Sie die Weboberfläche Ihrer Kamera im Browser aufrufen, werden Sie von dem Live Video begrüßt werden. Sollten Sie hier kein Video sehen, lesen Sie bitte zuerst unsere `}<a parentName="p" {...{
        "href": "/de/Schnell_Installation/Live_Video/"
      }}>{`Plugin Anleitung`}</a>{` um das richtige Video Plugin zu aktivieren.`}</p>
    <h3 {...{
      "id": "einstellungen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#einstellungen",
        "aria-label": "einstellungen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Einstellungen`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/720674b9fd0935ad175ca8eb8446664c/22c86/1440p_Settings_Live_Video.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.17391304347826%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACqklEQVQoz03RSU8TARiH8UlIMBiNJkK0sgiiQul0hpa2A91mpjPTmUqLUMSwVCpaEFtQDLIqUSNI9WAMxCXGxLhFD3rw7MWriTFx+QBePfoJHtPEg4ff9cn7zyv83LePH7t28b2mhu/V1XwTBHJeCVnVCHT3ICs9yN1RpJCCHFLwh7qR/SHkYIijosT07EXyExP4AwFiqoZwVfRy1SOy2uFhuc3NSrubWKubzsMyphRlOpFk84TN8sAosycnWL9xg7Wba+TTQ4wZx5nKnGQgYuJvakNsdSOEe9P0VBxPE7RTyKbNqJMiH3UYlPvYGszzeuosb4pFnq3e5e32Jo+vneHD2iLb54ssZUZZS2e51KNgHXMjWLZDhW5YqLpBPGGgKTr5sM39QpmnpReUJ5fZHBtmNp1lrj/Dw8nTvLoyw/PFTbZyCzwYzDKvR8gqKoJhp0jYDqqZJJ4wiZoWpi9G1hdhJXeeM2aR8eQpSmMXmBufYWOqwOUTI6wPlbifP8vz6WFuF8t0B4fwSQGESqxC+xdUNJNin0rsWAvi/gbOKV4KMR99wzOkNYcx2yYlB/h8a4I/j0b4tSHz9ck93i1doqAF/wWTDvHKZMMkGDcpZRTuzRUYiMYZko6Si3ShyiKNrgMcqW9iaTDBywWLmUgrD+1D/Fhw8ftyPe/zEoKV6sV0UuhJm1jCREs6uFwNlMfjXB/Vebpg83E5hOpuYm/tAfSuAKcmc3QGw3haOmmscyE11bHYVcOjdCOCbtloVpK4YRLVDQwnxe5aF8kGgU93M3wpB7hjtSI1N5CSm7m1vsF8aZI9e+poaz7Mwf31VFftYGdVFb0texEqV/2v8pwOyUe0q50+I0B/WCTmC+PzdqL6RQZGRlCjYdo7vPiDCh5fiHaPSJu7A6/o5S8VznmJA6iBFAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/720674b9fd0935ad175ca8eb8446664c/e4706/1440p_Settings_Live_Video.avif 230w", "/de/static/720674b9fd0935ad175ca8eb8446664c/d1af7/1440p_Settings_Live_Video.avif 460w", "/de/static/720674b9fd0935ad175ca8eb8446664c/7f308/1440p_Settings_Live_Video.avif 920w", "/de/static/720674b9fd0935ad175ca8eb8446664c/db25a/1440p_Settings_Live_Video.avif 1143w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/720674b9fd0935ad175ca8eb8446664c/a0b58/1440p_Settings_Live_Video.webp 230w", "/de/static/720674b9fd0935ad175ca8eb8446664c/bc10c/1440p_Settings_Live_Video.webp 460w", "/de/static/720674b9fd0935ad175ca8eb8446664c/966d8/1440p_Settings_Live_Video.webp 920w", "/de/static/720674b9fd0935ad175ca8eb8446664c/7e370/1440p_Settings_Live_Video.webp 1143w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/720674b9fd0935ad175ca8eb8446664c/81c8e/1440p_Settings_Live_Video.png 230w", "/de/static/720674b9fd0935ad175ca8eb8446664c/08a84/1440p_Settings_Live_Video.png 460w", "/de/static/720674b9fd0935ad175ca8eb8446664c/c0255/1440p_Settings_Live_Video.png 920w", "/de/static/720674b9fd0935ad175ca8eb8446664c/22c86/1440p_Settings_Live_Video.png 1143w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/720674b9fd0935ad175ca8eb8446664c/c0255/1440p_Settings_Live_Video.png",
              "alt": "Web User Interface - 1440p Series - Live_Video",
              "title": "Web User Interface - 1440p Series - Live_Video",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Wenn Sie oben links auf `}<strong parentName="p">{`Einstellungen`}</strong>{` klicken, erhalten Sie Zugriff auf die Einstellungen Ihrer Kamera. Dieses Menü beinhaltet alle Punkte, die in unserer `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Auswahl/"
      }}>{`Web User Interface Anleitung`}</a>{` beschrieben sind.`}</p>
    <h3 {...{
      "id": "ptz",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#ptz",
        "aria-label": "ptz permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`PTZ`}</h3>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/45f315f0bb894c610364bf3b1bb566a1/cd1d6/1440p_View_Relay.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "51.30434782608696%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACuUlEQVQozx3M209TBwCA8ROxCyKRoC1aKG3PaUtvWGsv5xwKvdDaMhBs0FZo4RROHVah3hYUhtqBFxAacRVJNEum2YxvPvviv7DtZf/Pt4SHL/k9fYI8FCMsKwQjMhfCMlElhqzESCZTXLo8ReJSlrA8RCga42JEJXJkhUBIJhhVCaojXFCGOS/HCA3FEUymM5iNRoKimx+jKmPRUQpqlldaiY872/y++47mszU26hpP9Rvcyl+jnJnkajhCOKAgVTZxLW4RuN3EM/MzQmeXiZOneogFVabjWSqZq+zquzSXGrzSNdbLOo1alfcPdD43GrzQH/KyqLGeGyalZpGWW/juHaI++QvP4q8IStjPL8sVvh7sU4uPM5cZ50l1kxv5OnVtibpW49G8xv1rFZ4t3OVgpUbz9hq5xHXkxARGbRuT9pJz1Sb9xVWEi04zaiRI3O9hs5hCGfSTGvSzMBKkkC8znS9RHMuhZ9P811rh76fD/Pt+jS/rq5THM7iX39BbbTL8+A8CegOhzXAKQRCOmlbdPP5pjoTHRTWnUEhGsVlt+EQnjaUrPCol0WU3f1Yl/rlj59OtNN3z25gXdzizsEdvYRXh2HEDFouFHwyGo+nWpJXDOwm+bSWZHXEjiSLzxQKzuoYkDeKUvBhPnyUjdVEf9eKrv+WcvsfA3UOk8gaCTXQgORw4B9y0tRm4OXqWVi1EazZCIhAmHXDQ2m8ylc3gtNlxuQaw20XG0imuT+Xo0Z5jquzQozexFB8idJ/uxmqz02/uYcLbjtfagSAc50PBzfeShVLExfTNGr5QEL/fQ5+1jwGPi5nJNFPx83hWfqN/6TWO+jsccxsIJzo66Ozsoho7ibevHeFYO9E+M3sWEy9EI4pPQpnJMbGYZ3Qmhyvqxe4WEZ1WOnutOPTnWLQtbNVtxMID/gd+aW1JgbCvEwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/45f315f0bb894c610364bf3b1bb566a1/e4706/1440p_View_Relay.avif 230w", "/de/static/45f315f0bb894c610364bf3b1bb566a1/d1af7/1440p_View_Relay.avif 460w", "/de/static/45f315f0bb894c610364bf3b1bb566a1/7f308/1440p_View_Relay.avif 920w", "/de/static/45f315f0bb894c610364bf3b1bb566a1/fc952/1440p_View_Relay.avif 1141w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/45f315f0bb894c610364bf3b1bb566a1/a0b58/1440p_View_Relay.webp 230w", "/de/static/45f315f0bb894c610364bf3b1bb566a1/bc10c/1440p_View_Relay.webp 460w", "/de/static/45f315f0bb894c610364bf3b1bb566a1/966d8/1440p_View_Relay.webp 920w", "/de/static/45f315f0bb894c610364bf3b1bb566a1/91464/1440p_View_Relay.webp 1141w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/45f315f0bb894c610364bf3b1bb566a1/81c8e/1440p_View_Relay.png 230w", "/de/static/45f315f0bb894c610364bf3b1bb566a1/08a84/1440p_View_Relay.png 460w", "/de/static/45f315f0bb894c610364bf3b1bb566a1/c0255/1440p_View_Relay.png 920w", "/de/static/45f315f0bb894c610364bf3b1bb566a1/cd1d6/1440p_View_Relay.png 1141w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/45f315f0bb894c610364bf3b1bb566a1/c0255/1440p_View_Relay.png",
              "alt": "Web User Interface - 1440p Series - Live_Video",
              "title": "Web User Interface - 1440p Series - Live_Video",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Wenn Sie über ein schwenkbares Kameramodell verfügen, bewegen Sie einfach Ihren Mauszeiger über das Live Video, um das Steuerkreuz, unten links, einzublenden. Verwenden Sie die Pfeiltasten um die Kamera in die entsprechende Richtung zu schwenken.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/08a97b2ffd1012c3fd03b0d6c1e3c238/8740f/1440p_View_PTZ.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "51.73913043478261%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACtElEQVQozyWQXU9TBwCGD7jN2CqLrbRSPko/zikth41+nJ7TTyhq2QCrFOihtZQKpatYgRAlQ6sDJkVnAS/cjBe78MJkiVe72P0S/4N/5zHFiyd5L968yfsI0UQSNRpDiUQIajHCsThBtZ2j+NUockBB9of4MRQ+Y1RR8bcJa197YY1AWGU0pKJoUQQ5lUeerOK/UaKWlihkZ5iZzZHNzrGdGaGpy+zqIcaSMWKxBJFIhLAaJRgME9ASOPWHOAu7DJefIS4+RDBcMvOd0YzPIaOnJtDHb1KfesDh8jat1RKHlTVePbrP6UaB940dGqUNdueKPJ5K8lMwhnTvFM/mW8b2P+Crv0Zwul0sZKb562CPRXWSu+lbnG6+YSP3lK3iKtW5Eps5nUZxhb3lBxxVtnierzEbnyaiXcda/B1LqYl5qYkl/wwhMWJj+dY11rMzPMmk8IservsV8lGF+UyeO3qF6sI8+fEb/H+4zadGik9/Njiq7/NzPI70yyv6KseoO+9QNk8QOs8ZEQThjPLEMFvFBeKSm0LCTzYVRxI9DA262CmkeVu/xv6kl//qPj7/Oso/tSQ9xQMs5RdnWAu/tXc6MZtNdHR0Yvj2PHuzwzyaD/GxkWJlwovN1kt6bIylyhKyHMI14GXI3ktu5HteZCSGay36qicM1l4zuNJE6Lb24HKL2O12BKGD9fHLfHys8XfZj+b9Ac1np9U8YDF7G3tvPx7Jg8nUzUWDgYTYg6N8wJXll/Ss/IFtaR/BYrViH3Rw1dbPhGRAEbvaHmhlh/i3KKEHnOjVddw+mSHRjUt0Ybh4gW7jOaZHriCuHWGvHjNQPcZx93n7soDR2EUx8A3y1Y4zl16TiVafiTdOIwm3DSWXZqpym2Q2hSvkwebopevyJUyWbhyrR/StndBfPWWgfMgXSfRnyh/nG8QAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/08a97b2ffd1012c3fd03b0d6c1e3c238/e4706/1440p_View_PTZ.avif 230w", "/de/static/08a97b2ffd1012c3fd03b0d6c1e3c238/d1af7/1440p_View_PTZ.avif 460w", "/de/static/08a97b2ffd1012c3fd03b0d6c1e3c238/7f308/1440p_View_PTZ.avif 920w", "/de/static/08a97b2ffd1012c3fd03b0d6c1e3c238/789e4/1440p_View_PTZ.avif 1106w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/08a97b2ffd1012c3fd03b0d6c1e3c238/a0b58/1440p_View_PTZ.webp 230w", "/de/static/08a97b2ffd1012c3fd03b0d6c1e3c238/bc10c/1440p_View_PTZ.webp 460w", "/de/static/08a97b2ffd1012c3fd03b0d6c1e3c238/966d8/1440p_View_PTZ.webp 920w", "/de/static/08a97b2ffd1012c3fd03b0d6c1e3c238/3fe5f/1440p_View_PTZ.webp 1106w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/08a97b2ffd1012c3fd03b0d6c1e3c238/81c8e/1440p_View_PTZ.png 230w", "/de/static/08a97b2ffd1012c3fd03b0d6c1e3c238/08a84/1440p_View_PTZ.png 460w", "/de/static/08a97b2ffd1012c3fd03b0d6c1e3c238/c0255/1440p_View_PTZ.png 920w", "/de/static/08a97b2ffd1012c3fd03b0d6c1e3c238/8740f/1440p_View_PTZ.png 1106w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/08a97b2ffd1012c3fd03b0d6c1e3c238/c0255/1440p_View_PTZ.png",
              "alt": "Web User Interface - 1440p Series - Live_Video",
              "title": "Web User Interface - 1440p Series - Live_Video",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Klicken Sie auf `}<strong parentName="p">{`Positionen`}</strong>{`, oben in der Mitte des Live Videos, um das Menü zum Speichern und Anfahren von Kamera Positionen zu öffnen. Diese Positionen können Sie anschließend z.B. als `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Features/PTZ/"
      }}>{`Alarm oder Start Position`}</a>{` nutzen. Sie erleichtern auch die Kontrolle über das Schwenken der Kamera mit unserer Smartphone App.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/43e4cbe032965c3a4265ef05a287caab/23725/1440p_View_PTZ_Save.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "10%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAACCAIAAADXZGvcAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAAfklEQVQI1wXBSw6CMBAAUO5h4tKFNsZ+aBlCi2QoTluQBTHRK+jCRoPn970iTFcfE1JACg49NBbAaK1kBRyc1EaURuiaaXdQzY7x7/rLOUulrHNFT7GniBRaf2kRyy7x6cXGt8fuObK4PNJyv83+Q5s1bme7Pw8J++F4EhrqP16MH3Rfa2aVAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/43e4cbe032965c3a4265ef05a287caab/e4706/1440p_View_PTZ_Save.avif 230w", "/de/static/43e4cbe032965c3a4265ef05a287caab/d1af7/1440p_View_PTZ_Save.avif 460w", "/de/static/43e4cbe032965c3a4265ef05a287caab/7f308/1440p_View_PTZ_Save.avif 920w", "/de/static/43e4cbe032965c3a4265ef05a287caab/6c16e/1440p_View_PTZ_Save.avif 1105w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/43e4cbe032965c3a4265ef05a287caab/a0b58/1440p_View_PTZ_Save.webp 230w", "/de/static/43e4cbe032965c3a4265ef05a287caab/bc10c/1440p_View_PTZ_Save.webp 460w", "/de/static/43e4cbe032965c3a4265ef05a287caab/966d8/1440p_View_PTZ_Save.webp 920w", "/de/static/43e4cbe032965c3a4265ef05a287caab/e8613/1440p_View_PTZ_Save.webp 1105w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/43e4cbe032965c3a4265ef05a287caab/81c8e/1440p_View_PTZ_Save.png 230w", "/de/static/43e4cbe032965c3a4265ef05a287caab/08a84/1440p_View_PTZ_Save.png 460w", "/de/static/43e4cbe032965c3a4265ef05a287caab/c0255/1440p_View_PTZ_Save.png 920w", "/de/static/43e4cbe032965c3a4265ef05a287caab/23725/1440p_View_PTZ_Save.png 1105w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/43e4cbe032965c3a4265ef05a287caab/c0255/1440p_View_PTZ_Save.png",
              "alt": "Web User Interface - 1440p Series - Live_Video",
              "title": "Web User Interface - 1440p Series - Live_Video",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Bewegen Sie Ihre Kamera auf eine Position, schalten Sie das Dropdown-Menü auf `}<strong parentName="p">{`Speichern Position`}</strong>{` und wählen Sie ein Preset aus, dem Sie diesem zuordnen möchten.`}</p>
    <p>{`Um die Funktion `}<strong parentName="p">{`Scan`}</strong>{` zu nutzen, können Sie hier einen Start- und Endpunkt festlegen. Der Scan schwenkt die Kamera nur zwischen diesen Punkten horizontal. Die Höhe des Scans wird durch die Position definiert, in der sich die Kamera befindet, wenn Sie den Scan starten.`}</p>
    <h3 {...{
      "id": "sd-karte",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#sd-karte",
        "aria-label": "sd karte permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`SD Karte`}</h3>
    <h4 {...{
      "id": "übersicht-über-ihre-aufnahmen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#%C3%BCbersicht-%C3%BCber-ihre-aufnahmen",
        "aria-label": "übersicht über ihre aufnahmen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Übersicht über Ihre Aufnahmen`}</h4>
    <p>{`Der SD-Viewer gibt Ihnen die Möglichkeit die Bilder als Vorschau darstellen zu lassen. Um die Vorschau anzuzeigen können Sie einfach auf den Bildernamen oder auf das Vorschausymbol klicken. Bilder und Videos können Sie mithilfe des Download-Buttons direkt auf Ihrem Rechner speichern.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/42fcee4ee26fba17aa80069efbda7cee/b5cea/1440p_View_SD_Card.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70.43478260869564%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAA7rAAAO6wFxzYGVAAADBUlEQVQ4y3WTu3JbVRSGVVDAMECYgBwlsmRdYmCwrJvPkY4u57bP/SopsWUP40kIZLAVMwku0kABDU06ZtIyMLQUeQQanoGCgkf5mHNkOTQU/+x/N99e/15rFRq7H/GJ9QVN/5Id64JtcUHZePIfra79trmiYp5TMc9y3XVXdBfP6R1+S3O0oFy+TWGn0WQYnDI9eooyXzGYnTOcr5DTM6TkbO2TM+TkK3rhOR3/Ke3gGS3vG/rxJZ3wgsH8GR01pVQsUqg1mownI+I4IAw9gtAlin2EZaDpU4LARTc0TG1IxTjnjcd/8M73f/H+T//w9ou/eev5n7wZv2Cv1aV+5zaFWrPJSDMIZwu8OMWNEvx0ju74TIWDEyWolotqCj5WFyiPX7L88Xcuf33Fdz+/4uiHX9g/vqTdH1AtV9YVjlSdcDbHjxPcKCZIZhiOx9S08rsmbFTLQdlvYey2CA8UItXm5anHb18LnqxMZOmA9t3aFVDbAFO8KCFIN0AbN1wDJ8Jh2NtnId1CtMvsDWUafYlErnKkVNhr7dGqlihUa3VGqkaUzgiiGC+MCJME03bymF4QoguRe812EV6I6YUI188fHQuPqR3Q6vYp3rxJYadWR9FMnHsnWLMjRHqIvVgy8VOGToSZ3EdxY0aWj2E7mI6L5QVYfohuu3n1Gbjd6fHhjRsZsMbAcNCPv0Q9/Jzp/YfoR4+Qk8/oBsdM7j2gF50gubMcKDwf4QU5LPvjaVa54zHsdim+9y6Fan0TOb2KHOaRRRbZMHGD4DqymjVH2GiWk2sNtHJ4+0Dig2wOM+BY04lnc4IkxYsTwnR+3RQnjHNI5jeAtWym2QOmhWG7dKUBW6VsU+p1hlMDM1pgBilOEOajYlxFsvzgCvgallera6iGwVBYjByPjiSzdatEoVJvIjSFR8mApa/kndSvlMXanGu56JbN1IkYxQ+Y+EuOVZOHho18IFMslShs1xpMBm1OxS5z7VOk0QRJGf+vZGVEf2zQMpf5/i66Eid9me5+h6072/wL3TfxQQ9WAUoAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/42fcee4ee26fba17aa80069efbda7cee/e4706/1440p_View_SD_Card.avif 230w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/d1af7/1440p_View_SD_Card.avif 460w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/7f308/1440p_View_SD_Card.avif 920w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/0c10b/1440p_View_SD_Card.avif 1140w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/42fcee4ee26fba17aa80069efbda7cee/a0b58/1440p_View_SD_Card.webp 230w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/bc10c/1440p_View_SD_Card.webp 460w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/966d8/1440p_View_SD_Card.webp 920w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/c89f9/1440p_View_SD_Card.webp 1140w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/42fcee4ee26fba17aa80069efbda7cee/81c8e/1440p_View_SD_Card.png 230w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/08a84/1440p_View_SD_Card.png 460w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/c0255/1440p_View_SD_Card.png 920w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/b5cea/1440p_View_SD_Card.png 1140w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/42fcee4ee26fba17aa80069efbda7cee/c0255/1440p_View_SD_Card.png",
              "alt": "Web User Interface - 1440p Series - Live_Video",
              "title": "Web User Interface - 1440p Series - Live_Video",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h4 {...{
      "id": "vorschau-von-h265-videodateien",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#vorschau-von-h265-videodateien",
        "aria-label": "vorschau von h265 videodateien permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Vorschau von h.265-Videodateien`}</h4>
    <p>{`Ihre Kamera zeichnet standardmäßig Alarmvideos in voller Auflösung mit der h.265-Videokompression auf. Allerdings `}<a parentName="p" {...{
        "href": "https://caniuse.com/?search=hevc"
      }}>{`unterstützen z.Z. nur der Apple Safari Browser und der Microsoft Edge Browser (muss zuerst aktiviert werden!)`}</a>{` die Wiedergabe von h.265-Dateien. In anderen Browsern wie Firefox, Chrome, etc. können Sie Ihre Aufnahmen nicht direkt ansehen, sondern müssen sie zuerst herunterladen. Sie können `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Alarm/Aktionen/"
      }}>{`die Auflösung in den Einstellungen für die Alarmaktion auf 1080p ändern`}</a>{` und damit gleichzeitig die Videokomprimierung auf h.264 ändern. Nach dieser Änderung sollten Sie die Vorschaufunktion in den meisten Browsern nutzen können.`}</p>
    <DangerBox mdxType="DangerBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/42fcee4ee26fba17aa80069efbda7cee/b5cea/1440p_View_SD_Card.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70.43478260869564%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAA7rAAAO6wFxzYGVAAADBUlEQVQ4y3WTu3JbVRSGVVDAMECYgBwlsmRdYmCwrJvPkY4u57bP/SopsWUP40kIZLAVMwku0kABDU06ZtIyMLQUeQQanoGCgkf5mHNkOTQU/+x/N99e/15rFRq7H/GJ9QVN/5Id64JtcUHZePIfra79trmiYp5TMc9y3XVXdBfP6R1+S3O0oFy+TWGn0WQYnDI9eooyXzGYnTOcr5DTM6TkbO2TM+TkK3rhOR3/Ke3gGS3vG/rxJZ3wgsH8GR01pVQsUqg1mownI+I4IAw9gtAlin2EZaDpU4LARTc0TG1IxTjnjcd/8M73f/H+T//w9ou/eev5n7wZv2Cv1aV+5zaFWrPJSDMIZwu8OMWNEvx0ju74TIWDEyWolotqCj5WFyiPX7L88Xcuf33Fdz+/4uiHX9g/vqTdH1AtV9YVjlSdcDbHjxPcKCZIZhiOx9S08rsmbFTLQdlvYey2CA8UItXm5anHb18LnqxMZOmA9t3aFVDbAFO8KCFIN0AbN1wDJ8Jh2NtnId1CtMvsDWUafYlErnKkVNhr7dGqlihUa3VGqkaUzgiiGC+MCJME03bymF4QoguRe812EV6I6YUI188fHQuPqR3Q6vYp3rxJYadWR9FMnHsnWLMjRHqIvVgy8VOGToSZ3EdxY0aWj2E7mI6L5QVYfohuu3n1Gbjd6fHhjRsZsMbAcNCPv0Q9/Jzp/YfoR4+Qk8/oBsdM7j2gF50gubMcKDwf4QU5LPvjaVa54zHsdim+9y6Fan0TOb2KHOaRRRbZMHGD4DqymjVH2GiWk2sNtHJ4+0Dig2wOM+BY04lnc4IkxYsTwnR+3RQnjHNI5jeAtWym2QOmhWG7dKUBW6VsU+p1hlMDM1pgBilOEOajYlxFsvzgCvgallera6iGwVBYjByPjiSzdatEoVJvIjSFR8mApa/kndSvlMXanGu56JbN1IkYxQ+Y+EuOVZOHho18IFMslShs1xpMBm1OxS5z7VOk0QRJGf+vZGVEf2zQMpf5/i66Eid9me5+h6072/wL3TfxQQ9WAUoAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/42fcee4ee26fba17aa80069efbda7cee/e4706/1440p_View_SD_Card.avif 230w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/d1af7/1440p_View_SD_Card.avif 460w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/7f308/1440p_View_SD_Card.avif 920w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/0c10b/1440p_View_SD_Card.avif 1140w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/42fcee4ee26fba17aa80069efbda7cee/a0b58/1440p_View_SD_Card.webp 230w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/bc10c/1440p_View_SD_Card.webp 460w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/966d8/1440p_View_SD_Card.webp 920w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/c89f9/1440p_View_SD_Card.webp 1140w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/42fcee4ee26fba17aa80069efbda7cee/81c8e/1440p_View_SD_Card.png 230w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/08a84/1440p_View_SD_Card.png 460w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/c0255/1440p_View_SD_Card.png 920w", "/de/static/42fcee4ee26fba17aa80069efbda7cee/b5cea/1440p_View_SD_Card.png 1140w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/42fcee4ee26fba17aa80069efbda7cee/c0255/1440p_View_SD_Card.png",
              "alt": "Web User Interface - 1440p Series - Live_Video",
              "title": "Web User Interface - 1440p Series - Live_Video",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <h4 {...{
      "id": "alle-videos-und-bilder-laden",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#alle-videos-und-bilder-laden",
        "aria-label": "alle videos und bilder laden permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Alle Videos und Bilder laden`}</h4>
    <p>{`Wenn Sie nicht jede Datei einzeln runterladen möchten, dann können Sie das INSTAR Kamera Tool verwenden. Dieser hat einen integrierten Downloader für die SD Karte Ihrer Kamera. Dieser hat einen integrierten Downloader für die SD Karte Ihrer Kamera.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Starten Sie das Kameratool und klicken Sie den Reiter SD-Karte an. Wählen Sie anschliessend Ihre Kamera aus. Wenn nicht bereits geschehen, dann werden Sie nun aufgefordert sich bei der Kamera zu authentifizieren. Klicken Sie anschliessend auf `}<strong parentName="p">{`Durchsuchen`}</strong>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Klicken Sie ganz oben links auf die Auswahlbox um alle Ordner auf der SD Karte auszuwählen. Alternativ können Sie auch nur den gewünschten Ordner auswählen. Klicken Sie anschliessend auf Download. Der Download wird anschliessend gestartet und kann je nach Datenmenge einige Minuten dauern.`}</p>
      </li>
    </ol>
    <p>{`Sie können den Inhalt der SD Karte aber auch direkt über den Webbrowser aufrufen, indem Sie an die IP der Kamera in der Adresszeile ein `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/sd`}</code>{` anhängen:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/723c0c23e0e938d1b5109f717ff94b65/25260/1440p_SD_Card.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "14.782608695652174%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAIAAAAcOLh5AAAACXBIWXMAAA7rAAAO6wFxzYGVAAAAVElEQVQI143CiQ2AIAwAQNYASqk8BQPyGRP3n8wR8HKizVXaWM/b58TDK0BABLR/CpeukHsst+eELqcyjCWpQYHZFkCR8xk4BGaDWGq1RFJrBbD9AV+uFlQxDZAWAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/723c0c23e0e938d1b5109f717ff94b65/e4706/1440p_SD_Card.avif 230w", "/de/static/723c0c23e0e938d1b5109f717ff94b65/d1af7/1440p_SD_Card.avif 460w", "/de/static/723c0c23e0e938d1b5109f717ff94b65/7f308/1440p_SD_Card.avif 920w", "/de/static/723c0c23e0e938d1b5109f717ff94b65/e3393/1440p_SD_Card.avif 1113w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/723c0c23e0e938d1b5109f717ff94b65/a0b58/1440p_SD_Card.webp 230w", "/de/static/723c0c23e0e938d1b5109f717ff94b65/bc10c/1440p_SD_Card.webp 460w", "/de/static/723c0c23e0e938d1b5109f717ff94b65/966d8/1440p_SD_Card.webp 920w", "/de/static/723c0c23e0e938d1b5109f717ff94b65/9bbd4/1440p_SD_Card.webp 1113w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/723c0c23e0e938d1b5109f717ff94b65/81c8e/1440p_SD_Card.png 230w", "/de/static/723c0c23e0e938d1b5109f717ff94b65/08a84/1440p_SD_Card.png 460w", "/de/static/723c0c23e0e938d1b5109f717ff94b65/c0255/1440p_SD_Card.png 920w", "/de/static/723c0c23e0e938d1b5109f717ff94b65/25260/1440p_SD_Card.png 1113w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/723c0c23e0e938d1b5109f717ff94b65/c0255/1440p_SD_Card.png",
              "alt": "Web User Interface - 1440p Series - Live_Video",
              "title": "Web User Interface - 1440p Series - Live_Video",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      